import { useQuery } from '@tanstack/react-query';

import { MOCK_DRES } from '../dados-simulados';

/** Lista de DREs para preencher seletor de filtro — não paginada: é pequena e fixa. */
export function useDres() {
  return useQuery({
    queryKey: ['financeiro', 'dres'],
    queryFn: async () => MOCK_DRES,
    staleTime: 5 * 60_000,
  });
}
